import React from 'react';
import { MapPin, ChevronDown, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  return <header className="w-full bg-[#1C1C1C] border-b border-[#2A2A2A] sticky top-0 z-50" data-id="element-274">
      <div className="max-w-[1600px] mx-auto px-4 md:px-6 h-20 flex items-center justify-between" data-id="element-275">
        {/* Left: Logo & Nav */}
        <div className="flex items-center gap-8 lg:gap-12" data-id="element-276">
          {/* Logo */}
          <Link to="/" className="cursor-pointer flex-shrink-0" data-id="element-277">
            <img src="https://cdn.magicpatterns.com/uploads/eyDhwupaqmpcRwhonPYhLR/LUSSO_GROUP_LOGO.png" alt="Lusso Group" className="h-72 md:h-[336px] w-auto object-contain brightness-0 invert" data-id="element-278" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6 text-[15px] font-medium text-gray-300" data-id="element-279">
            <a href="#" className="hover:text-[#4A90E2] transition-colors" data-id="element-280">
              Comprar
            </a>
            <a href="#" className="hover:text-[#4A90E2] transition-colors" data-id="element-281">
              Vender/Canjear
            </a>
            <a href="#" className="hover:text-[#4A90E2] transition-colors" data-id="element-282">
              Financiación
            </a>
            <a href="#" className="hover:text-[#4A90E2] transition-colors" data-id="element-283">
              Investigar
            </a>
            <button className="flex items-center gap-1 hover:text-[#4A90E2] transition-colors" data-id="element-284">
              Más <ChevronDown className="w-4 h-4" data-id="element-285" />
            </button>
          </nav>
        </div>

        {/* Center: Services */}
        <div className="hidden md:flex items-center gap-4 text-[16px] font-semibold text-gray-300 tracking-wider mr-8" data-id="element-286">
          <span data-id="element-287">Compra</span>
          <span className="text-[#4A90E2] font-black text-xl" data-id="element-288">·</span>
          <span data-id="element-289">Venta</span>
          <span className="text-[#4A90E2] font-black text-xl" data-id="element-290">·</span>
          <span data-id="element-291">Financiación</span>
        </div>

        {/* Right: Actions */}
        <div className="flex items-center gap-6" data-id="element-292">
          {/* Instagram */}
          <a href="https://www.instagram.com/lussogroup.ba/" target="_blank" rel="noopener noreferrer" className="p-3 rounded-xl bg-[#2A2A2A] hover:bg-gradient-to-br hover:from-[#f09433] hover:via-[#e6683c] hover:to-[#bc1888] transition-all duration-300 shadow-md hover:shadow-lg hover:scale-110" data-id="element-293">
            <Instagram className="w-8 h-8 text-white transition-colors" strokeWidth={1.8} data-id="element-294" />
          </a>

          {/* Location */}
          <a href="https://maps.app.goo.gl/X7PnVEoo9oLiE8h29" target="_blank" rel="noopener noreferrer" className="hidden md:flex items-center gap-2 cursor-pointer group" data-id="element-295">
            <MapPin className="w-6 h-6 text-gray-400 group-hover:text-[#4A90E2] transition-colors" strokeWidth={1.5} data-id="element-296" />
            <div className="flex flex-col" data-id="element-297">
              <span className="text-[11px] text-gray-500 leading-tight" data-id="element-298">
                Ramos Mejia 1704
              </span>
              <span className="text-sm font-bold text-gray-200 leading-tight group-hover:text-[#4A90E2] transition-colors" data-id="element-299">
                General Alvarado 368
              </span>
            </div>
          </a>
        </div>
      </div>
    </header>;
}